import Highcharts from 'highcharts';

const IMG_POINT_SELECTOR = '.highcharts-point[role="img"]';

export function applyPointRoles (chart) {
    const points = chart.container?.querySelectorAll(IMG_POINT_SELECTOR) || [];
    const containers = new Set([...points].map((element) => element.parentNode));

    containers.forEach((container) => {
        const children = [...container.children];
        const isPointList = children.every((child) => child.matches(IMG_POINT_SELECTOR));

        if (!isPointList) return;

        children.forEach((child) => child.setAttribute('role', 'listitem'));
        container.setAttribute('role', 'list');
    });
}

export function registerPointRoleOverride () {
    Highcharts.addEvent(Highcharts.Chart, 'render', function () {
        applyPointRoles(this);
    });
}
